import { useState } from 'react'
import EstadoAsistencia from '../../../../../components/EstadoAsistencia/EstadoAsistencia'
import PageLoading from '../../../../../components/PageLoading/PageLoading'
import { useNotification } from '../../../../../context/NotificationManager/NotificationManager'
import {
  getAsistenciasLeadSinProfesor,
  updateAsistenciaLead
} from '../../../../../utils/api/asistencias'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { dateToString, monthToString } from '../../../../../utils/date'
import { downloadCSVFile, getCSVContent } from '../../../../../utils/csv'
import { dateTimeSort, textFilter } from '../../../../../utils/table'
import TableHeader from '../../../../../components/TableHeader/TableHeader'
import { IconButton, Link, Typography } from '@mui/material'
import InformationTable from '../../../../../components/Table/InformationTable'
import MesRecienteSelector from '../../../../../components/form/MesRecienteSelector/MesRecienteSelector'
import ProfesorSelector from '../../../../../components/form/ProfesorSelector/ProfesorSelector'
import css from './Pruebas.module.css'

const Pruebas = () => {
  const notification = useNotification()
  const queryClient = useQueryClient()

  const [mes, setMes] = useState(monthToString(new Date()))
  const [search, setSearch] = useState('')

  const { isLoading, data: pruebaList = [] } = useQuery({
    queryKey: [
      'planificacion',
      'asistencia',
      'list',
      'feedback',
      'sin-profesor',
      mes
    ],
    queryFn: () =>
      getAsistenciasLeadSinProfesor(mes)
        .then(datos =>
          datos.map(asistencia => ({
            ...asistencia,
            fecha: dateToString(asistencia.fecha)
          }))
        )
        .catch(err => {
          notification.error({
            title: 'Error al recuperar las pruebas',
            content: err
          })
          return []
        })
  })

  const { isPending: isUpdatingAsistencia, mutate: modificarAsistencia } =
    useMutation({
      mutationFn: updateAsistenciaLead,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['planificacion', 'asistencia', 'list']
        })
      },
      onError: err => {
        notification.error({
          title: 'Error al actualizar la asistencia',
          content: err
        })
      }
    })

  const handleExport = () => {
    const content = getCSVContent({
      columns: [
        'Lead',
        'Centro',
        'Fecha',
        'Hora',
        'Asignatura',
        'Clase',
        'Profesor',
        'Observaciones'
      ],
      data: pruebaList,
      transform: c => [
        c.feedbackNombre,
        c.centro,
        c.fecha,
        c.hora,
        `${c.asignatura} - ${c.nivel}`,
        c.clase,
        c.profesor,
        c.observaciones
      ]
    })
    downloadCSVFile(content, `pruebas-sin-profesor`)
  }

  const filterSearch = prueba => {
    return textFilter({
      object: prueba,
      fields: [
        'feedbackNombre',
        'centro',
        'fecha',
        'hora',
        'asignatura',
        'tipo',
        'nivel',
        'clase',
        'profesor',
        'observaciones'
      ],
      search: search
    })
  }

  const handleProfesorChange = (profesor, asistencia) => {
    if (isUpdatingAsistencia) return
    modificarAsistencia({
      id: asistencia.id,
      profesor: profesor.id
    })
  }

  return (
    <PageLoading isLoading={isLoading}>
      <TableHeader
        actions={
          <div className={css.actions}>
            <IconButton
              className={css.download}
              size='small'
              color='primary'
              onClick={handleExport}
            >
              <i className='material-icons'>download</i>
            </IconButton>
            <MesRecienteSelector
              className={css.mes}
              name='mes'
              label='Mes'
              value={mes}
              forwardOptions={1}
              backwardOptions={18}
              onChange={e => setMes(e.target.value)}
            />
          </div>
        }
        title={`${pruebaList.length} pruebas sin profesor`}
        search={search}
        onSearchChange={e => setSearch(e.target.value)}
      />
      {pruebaList.length === 0 && (
        <div className={css.empty}>
          <Typography className={css.placeholder} variant='body1'>
            No hay pruebas sin asignar profesor
          </Typography>
        </div>
      )}
      {pruebaList.length > 0 && (
        <InformationTable
          details={[
            { title: 'Lead', key: 'lead', sortKey: 'leadNombre' },
            { title: 'Fecha', key: 'fecha', sortFunction: dateTimeSort },
            { title: 'Asignatura', key: 'asignatura' },
            { title: 'Profesor', key: 'profesor', sortDisabled: true },
            {
              title: 'Asistencia',
              key: 'asistencia',
              align: 'center',
              sortDisabled: true
            },
            { title: 'Observaciones', key: 'observaciones', sortDisabled: true }
          ]}
          data={pruebaList.filter(filterSearch).map(prueba => ({
            key: prueba.id,
            lead: (
              <Link
                className={css.link}
                href={`/leads/${prueba.feedbackId}/ficha`}
              >
                {prueba.feedbackNombre}
              </Link>
            ),
            leadNombre: prueba.feedbackNombre,
            fecha: `${prueba.fecha} ${prueba.hora}`,
            asignatura: prueba.asignatura,
            profesor: (
              <ProfesorSelector
                className={css.input}
                name='profesor'
                label='Profesor'
                value={prueba.profesorId}
                onChange={(_e, value) => handleProfesorChange(value, prueba)}
              />
            ),
            asistencia: <EstadoAsistencia asistencia={prueba} />,
            observaciones: prueba.observaciones
          }))}
        />
      )}
    </PageLoading>
  )
}

export default Pruebas
